<template>
  <div class="section-os">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">OS</h1>
      </div>
      <div class="section-body">
        <div class="row">
          <div class="col-12 col-md-8 col-lg-12 col-xl-8">
            <PieChart
              v-if="osData && !isEmpty && !isError"
              :series="series"
              :labels="labels"
              :colors="colors"
              :showLegend="false"
            />
          </div>
          <div class="col-12 col-md-4 col-lg-12 col-xl-4">
            <LegendContainer :percentage="series" :labels="labels" :colors="colors" />
          </div>
        </div>
        <EmptyMessage v-if="!isLoading && isEmpty && !isError">
          ไม่พบข้อมูลในช่วงเวลาดังกล่าว
        </EmptyMessage>
        <EmptyMessage v-if="!isLoading && isError">
          <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
          <p>
            โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
            <a
              :href="`mailto:support@byteark.com`"
              target="_top"
            >support@byteark.com</a>
          </p>
          <span slot="code" class="code">error code : {{error.status || 'not found' }}</span>
        </EmptyMessage>
        <div v-if="isLoading" class="d-flex justify-content-center">
          <div class="spinner-border" role="status" />
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import _ from 'lodash';
import PieChart from '@/charts/PieChart.vue';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import LegendContainer from '@/components/LegendContainer.vue';

export default {
  props: ['osData', 'isLoading', 'isError', 'error'],
  components: {
    PieChart,
    Section,
    EmptyMessage,
    LegendContainer,
  },
  data() {
    return {
      series: [],
      colors: [
        '#4E55A6',
        '#8753AA',
        '#B74DA2',
        '#DF4B90',
        '#FB5276',
        '#FF6758',
        '#FF8537',
        '#FFA600',
      ],
      labels: [],
    };
  },
  watch: {
    osData() {
      this.createGraph();
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.osData);
    },
  },
  methods: {
    async createGraph() {
      const labels = _.map(this.osData, (value) => value.osFamily);
      const seriesData = _.map(
        this.osData,
        (value) => value.playbackIdUniquePercentage,
      );
      this.series = await seriesData;
      this.labels = await labels;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.section-os {
  .section {
    min-height: 350px;
  }
}
</style>
